import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=86efd2a8&"
import script from "./Submission.vue?vue&type=script&lang=ts&"
export * from "./Submission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports